import { render } from "./signature_step.vue?vue&type=template&id=1523e6dc"
import script from "./signature_step.vue?vue&type=script&lang=js"
export * from "./signature_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__